import React from "react";
import classnames from "classnames";
import selectFormat from "../selectFormat";
import metricDefinitions from "../../metricDefinitions";
import { useSelector } from "react-redux";

export default function DaysSober(props) {
  const { organization_name, permissions } = useSelector(
    (state) => state.static
  );
  let metrics = metricDefinitions(organization_name, permissions)["days_sober"]
    .metrics;

  return (
    <div className="col-12">
      {metrics
        .filter((metric) => metric.visible == true)
        .map((metric, index) => {
          return selectFormat(metric, index, props);
        })}
      <div className="py-3" />
    </div>
  );
}
